import { ProductAttributeSelectorProps } from '../config.types';
import { useProductToUIMapping } from '../useProductToUIMapping';
import React from 'react';

type AttributeSelectorProps = {
  attributeId: string;
} & ProductAttributeSelectorProps;

/**
 * Renders the Selector component associated with a product Attribute
 */
export const AttributeSelector = (props: AttributeSelectorProps) => {
  const { attributeId } = props;
  const { getAttributeById } = useProductToUIMapping();

  const attributeConfig = getAttributeById(attributeId);

  if (!attributeConfig) {
    return null;
  }

  const selectorConfig = attributeConfig.components.selector;
  const Element = selectorConfig.component;

  if (!Element) {
    return null;
  }

  return <Element {...props} {...selectorConfig.props} />;
};
